import styled from "styled-components";
import { Anchor, Type, CardContent } from "@ebscois/react-component-library";

export const RightRailImageAnchor = styled(Anchor)`
  width: 100%;
  display: block;
  background: ${({ theme }) => theme.colors.gray200};
  &:hover {
    text-decoration: none;
  }
`;

export const RightRailImage = styled.img`
  width: 100%;
  display: block;
`;

export const StyledCardContent = styled(CardContent)`
  background: ${({ theme }) => theme.colors.gray200};
  padding: ${({ theme }) => theme.space.md};
  max-width: 1440px;
  justify-content: space-between;
  display: flex;
  width: 100%;
`;

export const StyledHeading = styled(Type)`
  padding-bottom: ${({ theme }) => theme.space.sm};
`;
